import { render, staticRenderFns } from "./PencetakKurikulumMerdeka.vue?vue&type=template&id=8114905a&scoped=true"
import script from "./PencetakKurikulumMerdeka.vue?vue&type=script&lang=js"
export * from "./PencetakKurikulumMerdeka.vue?vue&type=script&lang=js"
import style0 from "./PencetakKurikulumMerdeka.vue?vue&type=style&index=0&id=8114905a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8114905a",
  null
  
)

export default component.exports